export default "__VITE_ASSET__tIpUaynz__"